import { eventListener, TOPICS } from "@origin-digital/event-dispatcher";

import { EnvironmentNames } from "@origin-digital/platform-enums";
import { webPlatformHandler } from "./handlers/webPlatformHandler";
import { nativePlatformHandler } from "./handlers/nativePlatformHandler";
import { SubscribeTopics } from "./mesh.types";

//Listener list should match type SubscribeTopics
const listenerNames: SubscribeTopics["topic"][] = [
  TOPICS.AUTH_USER,
  TOPICS.NAV_TO,
  TOPICS.NAV_TO_URL,
  TOPICS.NAV_BACK,
  TOPICS.NAV_CLOSE,
  TOPICS.NAV_COMPLETE,
  TOPICS.NAV_HREF,
  TOPICS.NAV_HREF_TITLE,
  TOPICS.HTTP_REQ_ERROR,
  TOPICS.OPEN_RESOURCE,
  TOPICS.FETCH_ACCESS_TOKEN,
  TOPICS.FETCH_USER_TOKEN,
  TOPICS.FETCH_PLATFORM_PARAMETERS,
  TOPICS.FETCH_NATIVE_FEATURES,
  TOPICS.STALE_DATA,
  TOPICS.TOAST_SHOW,
  TOPICS.FEEDBACK_FORM,
  TOPICS.MODAL_OPEN,
  TOPICS.MODAL_CLOSE,
  TOPICS.CHAT_MESSENGER_SHOW,
  TOPICS.CHAT_MESSENGER_HIDE,
  TOPICS.ASYNC_MESSENGER_OPEN,
  TOPICS.ASYNC_MESSENGER_CLOSE,
];

let unSubListeners: () => void;

export interface IInitHandler {
  isNative: boolean;
  environment: EnvironmentNames;
}

export function initHandler({ isNative, environment }: IInitHandler): void {
  const platformHandler = isNative
    ? nativePlatformHandler({ environment })
    : webPlatformHandler({ environment });
  unSubListeners = eventListener.addListeners(
    listenerNames,
    platformHandler.listener
  );
}

// export for testing
export function __unSubListeners(): void {
  if (unSubListeners) {
    unSubListeners();
  }
}
